import type { WidgetConfig } from "./types";

export const QTYPES = [
  { id: "text", label: "Text Input", icon: "Aa" },
  { id: "rating", label: "Star Rating", icon: "\u2b50" },
  { id: "dropdown", label: "Dropdown", icon: "\u25be" },
  { id: "checkbox", label: "Checkbox", icon: "\u2611" },
];

export const CAT_LABELS: Record<string, string> = {
  bugReport: "Bug Report",
  generalFeedback: "General Feedback",
  featureRequest: "Feature Request",
  all: "All Categories",
};

export const OPERATORS = [
  { id: "equals", label: "equals" },
  { id: "not_equals", label: "does not equal" },
  { id: "contains", label: "contains" },
  { id: "gt", label: "is greater than" },
  { id: "lt", label: "is less than" },
];

export const PRESET_COLORS = [
  "#FF8C21",
  "#3B82F6",
  "#00E5A0",
  "#A78BFA",
  "#FF4D6A",
  "#FBBF24",
  "#EC4899",
  "#14B8A6",
];

export const DEFAULT_CFG: WidgetConfig = {
  brandColor: "#FF8C21",
  position: "floating",
  buttonText: "Feedback",
  companyName: "",
  categories: { bugReport: true, generalFeedback: true, featureRequest: true },
  customQuestions: [],
  poweredBy: true,
  darkMode: false,
  collectEmail: true,
  maxRecordSec: 120,
};
